import { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { styled } from 'styled-components'

import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import {
  auctionBidsQuery,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, Modal } from '@b-stock/fe-core/bstock-react'

import { StatisticModalContent } from './StatisticModalContent'

const ModalContent = styled(Modal.Content)`
  max-width: 794px;
`

export const AuctionStatisticModal = ({
  closeModal,
  currency,
  listing,
}: {
  closeModal: () => void
  currency: string
  listing: OrchestratedAuctionListingDetails
}) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: [auctionBidsQuery.name] })
  }, [queryClient])

  const queryResult = auctionBidsQuery.useQuery({
    auctionId: listing.auction._id,
  })

  return (
    <Modal closeModal={closeModal}>
      <Modal.Header>
        <FormattedMessage id="Auction.statisticModal.title" />
      </Modal.Header>
      <ModalContent>
        <QueryLoadingManager {...queryResult}>
          {({ data }) => (
            <StatisticModalContent
              data={data}
              currency={currency}
              listing={listing}
            />
          )}
        </QueryLoadingManager>
      </ModalContent>
    </Modal>
  )
}
